import { render, staticRenderFns } from "./ResultGoodsSellers.vue?vue&type=template&id=8d86b6e0&scoped=true&"
import script from "./ResultGoodsSellers.vue?vue&type=script&lang=js&"
export * from "./ResultGoodsSellers.vue?vue&type=script&lang=js&"
import style0 from "./ResultGoodsSellers.vue?vue&type=style&index=0&id=8d86b6e0&scoped=true&lang=css&"
import style1 from "./ResultGoodsSellers.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d86b6e0",
  null
  
)

export default component.exports